module.exports = __webpack_public_path__ + "static/media/home-gallery.ada62f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-gallery.png
// module id = 1635
// module chunks = 0